import React from "react";

function Frame916Icon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="39.231"
      height="59.451"
      viewBox="0 0 39.231 59.451"
    >
      <g
        id="_9:16_non_active"
        data-name="9:16 non active"
        transform="translate(1.5 1.5)"
        opacity="0.5"
      >
        <g id="Group_28109" data-name="Group 28109" transform="translate(0 0)">
          <g id="Group_28107" data-name="Group 28107" transform="translate(0)">
            <g id="Group_28106" data-name="Group 28106">
              <path
                id="Path_18519"
                data-name="Path 18519"
                d="M0,19.81V0H36.229V19.81"
                transform="translate(36.229 56.451) rotate(180)"
                fill="none"
                stroke="#fff"
                strokeWidth="3"
              />
              <path
                id="Path_18520"
                data-name="Path 18520"
                d="M-22786.066-20112.656v-19.812h36.23v19.813"
                transform="translate(22786.066 20132.469)"
                fill="none"
                stroke="#fff"
                strokeWidth="3"
              />
            </g>
            <path
              id="Path_21909"
              data-name="Path 21909"
              d="M4.861,5.018c3.081,0,4.913-2.335,4.913-6.21a7.044,7.044,0,0,0-.981-3.875,4.336,4.336,0,0,0-3.9-2.14C2.283-7.207.386-5.488.386-3.081A3.779,3.779,0,0,0,4.269.778,3.134,3.134,0,0,0,7.382-1.135h.049C7.5,1.549,6.515,3.081,4.9,3.081A1.942,1.942,0,0,1,2.956,1.776H.54A4.127,4.127,0,0,0,4.861,5.018Zm.049-6.08A2.061,2.061,0,0,1,2.777-3.154a2.106,2.106,0,0,1,2.148-2.1A2.094,2.094,0,0,1,7.05-3.137,2.064,2.064,0,0,1,4.909-1.062Zm7.856,4.248A1.305,1.305,0,1,0,11.46,1.881,1.3,1.3,0,0,0,12.765,3.186Zm0-5.8A1.3,1.3,0,0,0,14.07-3.916a1.294,1.294,0,0,0-1.305-1.305A1.294,1.294,0,0,0,11.46-3.916,1.3,1.3,0,0,0,12.765-2.61Zm6.056,7.369h2.424v-11.7H18.813l-3.024,2.1v2.205l2.983-2.059h.049Zm9.761.268A4.166,4.166,0,0,0,33.073.892a3.756,3.756,0,0,0-3.867-3.859,3.219,3.219,0,0,0-3.113,1.905h-.049c-.057-2.643.932-4.208,2.562-4.208a1.915,1.915,0,0,1,1.905,1.3h2.408a4.1,4.1,0,0,0-4.3-3.235c-3.024,0-4.9,2.335-4.9,6.21A7.015,7.015,0,0,0,24.7,2.87,4.326,4.326,0,0,0,28.582,5.026Zm-.024-1.954A2.109,2.109,0,0,1,26.426.941a2.058,2.058,0,0,1,2.14-2.067A2.045,2.045,0,0,1,30.69.965,2.1,2.1,0,0,1,28.558,3.073Z"
              transform="translate(2.596 29.229)"
              fill="#fff"
            />
          </g>
        </g>
      </g>
    </svg>
  );
}

export default Frame916Icon;
